import React, {useState, useEffect} from 'react';
import './CustomSelect.css';

import {CaretDown, Check, X} from '@phosphor-icons/react'
import { useDetectClickOutside } from 'react-detect-click-outside';

function remove(arr, value) {
    var i = 0;
    while (i < arr.length) {
      if (arr[i] === value) {
        arr.splice(i, 1);
      } else {
        ++i;
      }
    }
    return arr;
}

const CustomSelect = (props) => {
    if(props !== undefined){
        function sortArray(obj) {
            const returnObject = obj.sort((a, b) => {
                if(b.label != "All") {
                    return a.label.localeCompare(b.label, undefined, {numeric: true, sensitivity: 'base'});
                }
                else return true;
            });
            return returnObject;
        }
    
        const [options, setOptions] = useState(sortArray(props.options));
        const [dropdown, setDropdown] = useState(false);
    
        const ref = useDetectClickOutside({ onTriggered: () => setDropdown(false) });
    
        useEffect(() => {
            const handleScroll = () => setDropdown(false);
            window.addEventListener("scroll", handleScroll);
            return () => window.removeEventListener("scroll", handleScroll);  // Cleanup on unmount
        }, []);
    
        function toggleDropdown() {
            setDropdown(!dropdown);
        }

        return (
            <div className='CustomSelect' ref={ref}>
                {
                    <>
                    <div className="CSBox d-flex space-between" onClick={()=>{toggleDropdown()}}>
                        <div className="CSTitle">
                            {
                                props.current[props.name].length >= 1 ? options.filter((option) => option.value === props.current[props.name][0])[0] != undefined ? options.filter((option) => option.value === props.current[props.name][0])[0].label : props.title : props.title
                            }
                            {
                                props.current[props.name].length > 1 ? " + " + (props.current[props.name].length - 1) + " more" : ""
                            }
                        </div>
                        <div className={`CSDropNav ${dropdown && "close"}`}>
                            <CaretDown size={15} />
                        </div>
                    </div>
                    <div className={`CSDropdownContent bg-light shadow ${!dropdown && 'hidden'} d-flex col`}>
                        {
                            options.map((option, index) => { //for the love of god, please don't break this
                                return (
                                    <div className="CSOption" key={index} onClick={
                                        () => {
                                            if(props.current[props.name].length === 1 && props.current[props.name].includes(option.value)) {
                                                props.set({...props.current, [props.name]: ["all"]})
                                            }
                                            else {
                                                if(option.value === "all") {
                                                    props.set({...props.current, [props.name]: ["all"]})
                                                }
                                                else {
                                                    props.set(
                                                        {...props.current, [props.name]: props.current[props.name].includes(option.value) ? props.current[props.name].filter((value) => value !== option.value) : remove([...props.current[props.name], option.value],"all")}
                                                    )
                                                }
                                            }
                                        }
                                    }>
                                        <span>
                                        {
                                            props.current[props.name].includes(option.value) ? 
                                            <div><Check size={15} className="CSOptionCheck" /><label className="CSOptionLabel">{option.label}</label></div> :
                                            <div>&nbsp;&nbsp;<label className="CSOptionLabel">{option.label}</label></div>
                                        }
                                        </span>
                                    </div>
                                )
                            })
                        }
                    </div>
                    </>
                }
            </div>
        );
    }
};

export default CustomSelect;